export default __webpack_public_path__ + "ee0b44c4967d5ef03372a66b78fb3b0f.gif";